// extracted by mini-css-extract-plugin
export var bottomMargin = "defaultTopper-module--bottomMargin--7bdf1";
export var dark = "defaultTopper-module--dark--6bc04";
export var headerAnimatedGif = "defaultTopper-module--headerAnimatedGif--bd51c";
export var headerSlider = "defaultTopper-module--headerSlider--0599e";
export var highlightStaticImg = "defaultTopper-module--highlightStaticImg--94bce";
export var inner = "defaultTopper-module--inner--815ca";
export var intro = "defaultTopper-module--intro--6b6ab";
export var introLink = "defaultTopper-module--introLink--0df36";
export var light = "defaultTopper-module--light--a7784";
export var modalVideo = "defaultTopper-module--modal-video--72e70";
export var modalVideoBody = "defaultTopper-module--modal-video-body--9c9f3";
export var modalVideoCloseBtn = "defaultTopper-module--modal-video-close-btn--3af46";
export var modalVideoEffectExit = "defaultTopper-module--modal-video-effect-exit--f13c1";
export var modalVideoInner = "defaultTopper-module--modal-video-inner--6f964";
export var modalVideoMovieWrap = "defaultTopper-module--modal-video-movie-wrap--25b76";
export var noBottomPadding = "defaultTopper-module--no-bottom-padding--da76c";
export var section = "defaultTopper-module--section--9096b";
export var subtitle = "defaultTopper-module--subtitle--e379a";
export var title = "defaultTopper-module--title--4b11d";
export var titleBlack = "defaultTopper-module--title-black--afdd0";
export var titleRed = "defaultTopper-module--title-red--06cec";
export var titleWhite = "defaultTopper-module--title-white--60ae8";